/* Steelmonks – Monogramme ohne Zepto: zeichnet ein Monogramm (Buchstabenbild + Texte) aus den Zepto-Daten
   in der gewählten Finition. SMMono.render(design, values, finish) → Promise<canvas 1000×1000, transparent> */
(function(){
  var M=window.SMMono={}, imgs={}, fonts={}, uid=0;
  function img(u){ if(!imgs[u]) imgs[u]=new Promise(function(ok,no){ var i=new Image(); i.crossOrigin='anonymous'; i.onload=function(){ok(i);}; i.onerror=function(){no(u);}; i.src=u; }); return imgs[u]; }
  function font(u){
    if(!fonts[u]){ var fam='smm'+(++uid); fonts[u]=new FontFace(fam,'url('+u+')').load().then(function(f){ document.fonts.add(f); return fam; }).catch(function(){ return 'Georgia'; }); }
    return fonts[u];
  }
  M.preload=function(d){ var p=d.texts.map(function(t){return font(t.font);}); if(d.base) p.push(img(d.base).catch(function(){})); return Promise.all(p); };
  // Finitionen: 0 Noir, 1 Blanc, 2 Anthracite, 3 Or, 4 Inox, 5 Corten
  M.FIN=[{n:'Noir',c:'#1b1b1b'},{n:'Blanc',c:'#f3f3f1'},{n:'Anthracite',c:'#3b4045'},{n:'Or',c:'#c7a24a'},{n:'Inox',c:'#b9bcbf'},{n:'Corten',c:'#8a4a24'}];
  M.tex={};
  // Band im Motiv suchen: Lauf der Hintergrundfarbe (hell für schwarze Schrift, dunkel für weiße) zwischen zwei Stegen
  function band(px,x,yc,win,wantLight){
    var runs=[], cur=null;
    for(var y=Math.max(0,yc-win);y<=Math.min(999,yc+win);y++){
      var i=(y*1000+x)*4, l=px[i]*.3+px[i+1]*.59+px[i+2]*.11, on=wantLight?l>150:l<120;
      if(on){ if(!cur) cur=[y,y]; else cur[1]=y; } else if(cur){ runs.push(cur); cur=null; }
    }
    if(cur) runs.push(cur);
    runs=runs.filter(function(r){ return r[1]-r[0]>=28&&r[1]-r[0]<=230&&r[0]>Math.max(0,yc-win)&&r[1]<Math.min(999,yc+win); });
    runs.sort(function(a,b){ return Math.abs((a[0]+a[1])/2-yc)-Math.abs((b[0]+b[1])/2-yc); });
    return runs[0]||null;
  }
  // Bogentext: äußerstes Band zwischen zwei Ringen (oben: kleinstes y, unten: größtes y)
  function outer(px,top,wantLight){
    var y0=top?0:640, y1=top?360:999, runs=[], cur=null;
    for(var y=y0;y<=y1;y++){ var i=(y*1000+500)*4, l=px[i]*.3+px[i+1]*.59+px[i+2]*.11, on=wantLight?l>150:l<120;
      if(on){ if(!cur) cur=[y,y]; else cur[1]=y; } else if(cur){ runs.push(cur); cur=null; } }
    if(cur) runs.push(cur);
    runs=runs.filter(function(r){ return r[1]-r[0]>=28&&r[1]-r[0]<=230&&r[0]>y0&&r[1]<y1; });
    if(!runs.length) return null; return top?runs[0]:runs[runs.length-1];
  }
  // Länge des Stegs (dunkle Zeile) links/rechts von cx – Schrift darf nicht über den Steg hinaus
  function barW(px,cx,y){ if(y<0||y>999) return 1e9; function dk(x){ var i=(y*1000+x)*4; return px[i]*.3+px[i+1]*.59+px[i+2]*.11<120; }
    var gap=0, l=cx, r=cx; for(var x=cx;x>0;x--){ if(dk(x)){ gap=0; l=x; } else if(++gap>6) break; } gap=0; for(var x2=cx;x2<999;x2++){ if(dk(x2)){ gap=0; r=x2; } else if(++gap>6) break; }
    return r-l; }
  function capOf(ctx,fam){ ctx.font='100px "'+fam+'"'; var m=ctx.measureText('H'); return (m.actualBoundingBoxAscent||70)/100; }
  function flatAt(ctx,fam,txt,cx,base,cap,maxW){
    var fs=cap/capOf(ctx,fam); ctx.font=fs+'px "'+fam+'"'; var w=ctx.measureText(txt).width;
    ctx.textAlign='center'; ctx.textBaseline='alphabetic';
    if(w>maxW){ ctx.save(); ctx.translate(cx,base); ctx.scale(maxW/w,1); ctx.fillText(txt,0,0); ctx.restore(); } // zu lang: waagerecht stauchen, Höhe bleibt (berührt die Stege)
    else ctx.fillText(txt,cx,base);
  }
  function arcAt(ctx,fam,txt,cx,cy,rBase,cap,top,maxAng){
    var fs=cap/capOf(ctx,fam); ctx.font=fs+'px "'+fam+'"'; ctx.textAlign='center'; ctx.textBaseline='alphabetic';
    var ws=[].map.call(txt,function(c){return ctx.measureText(c).width;}), tot=ws.reduce(function(a,b){return a+b;},0), rm=top?rBase+cap/2:rBase-cap/2, k=1;
    if(tot/rm>maxAng) k=maxAng*rm/tot; // zu lang: Buchstaben schmaler
    var ang=tot*k/rm, a=top?-Math.PI/2-ang/2:Math.PI/2+ang/2;
    for(var i=0;i<txt.length;i++){
      var half=ws[i]*k/2/rm; a+=top?half:-half;
      ctx.save(); ctx.translate(cx+rBase*Math.cos(a),cy+rBase*Math.sin(a)); ctx.rotate(top?a+Math.PI/2:a-Math.PI/2); ctx.scale(k,1); ctx.fillText(txt[i],0,0); ctx.restore();
      a+=top?half:-half;
    }
  }
  function drawText(ctx,px,t,fam,txt){
    var light=!/^#f/i.test(t.color), cx=Math.round(t.x*10), yc=Math.round((t.y+t.h/2)*10), maxW=t.w*10, ov=light?4:-14;
    // ausgeschnittene (weiße) Schrift bleibt mit Rand im Metall; Akzente (É, È …) brauchen oben Platz
    var acc=/[ÀÂÄÉÈÊËÎÏÔÖÙÛÜÇŸ]/.test(txt), shrink=acc?(light?0.86:0.8):1;
    if(txt.length===1&&t.role==='letter'){ var cap=t.h*10*.62; flatAt(ctx,fam,txt,cx,yc+cap/2,cap,maxW); return; }
    if(t.curve){
      var top=t.r<0, CY=500, b=outer(px,top,light);
      if(b){ var rIn=top?CY-b[1]:b[0]-CY, rOut=top?CY-b[0]:b[1]-CY, cap=((rOut-rIn)+2*ov)*shrink; arcAt(ctx,fam,txt,500,CY,top?rIn-ov:rOut+ov,cap,top,Math.PI*.78); return; }
      var r=Math.abs(t.r), cap2=Math.min(t.h*10*.6,60); arcAt(ctx,fam,txt,cx,top?yc+r:yc-r,top?r-cap2/2:r+cap2/2,cap2,top,Math.PI*.7); return;
    }
    var b2=band(px,cx,yc,90,light);
    if(b2&&(b2[1]-b2[0])<=t.h*10*1.6){ var cap3=((b2[1]-b2[0])+2*ov)*shrink, bw=Math.min(barW(px,cx,b2[0]-3),barW(px,cx,b2[1]+3)); if(bw>80) maxW=Math.min(maxW,bw-24); flatAt(ctx,fam,txt,cx,b2[1]+ov,cap3,maxW); return; }
    var cap4=t.h*10*.55; flatAt(ctx,fam,txt,cx,yc+cap4/2,cap4,maxW);
  }
  // Graustufen-Entwurf: Metall = dunkel, Hintergrund/Ausschnitte = hell
  M.draft=function(d,V){
    var c=document.createElement('canvas'); c.width=c.height=1000; var ctx=c.getContext('2d'); ctx.fillStyle='#fff'; ctx.fillRect(0,0,1000,1000);
    var L=(V.letter||'A').toUpperCase(), jobs=[];
    if(d.letterImg&&d.letterImg.map[L]) jobs.push(img(d.letterImg.map[L])); else if(d.base) jobs.push(img(d.base)); else jobs.push(Promise.resolve(null));
    d.texts.forEach(function(t){ jobs.push(font(t.font)); });
    return Promise.all(jobs).then(function(r){
      if(r[0]) ctx.drawImage(r[0],0,0,1000,1000);
      var px=ctx.getImageData(0,0,1000,1000).data;
      d.texts.forEach(function(t,i){
        var txt=(t.role==='letter'?L:(V[t.role]||'')).replace(/\s+/g,' ').trim(); if(!txt) return; if(t.upper) txt=txt.toUpperCase();
        ctx.fillStyle=/^#f/i.test(t.color)?'#ffffff':'#000000'; drawText(ctx,px,t,r[i+1],txt);
      });
      return c;
    });
  };
  // Einfärben: dunkle Pixel → Metall (Textur oder Farbe), Rest transparent
  M.paint=function(draft,fin,texImg){
    var W=1000, c=document.createElement('canvas'); c.width=c.height=W; var ctx=c.getContext('2d');
    if(texImg){ ctx.drawImage(texImg,0,0,W,W); } else { ctx.fillStyle=M.FIN[fin].c; ctx.fillRect(0,0,W,W);
      if(fin===3){ var g=ctx.createLinearGradient(0,0,W,W); g.addColorStop(0,'rgba(255,240,190,.35)'); g.addColorStop(.5,'rgba(0,0,0,0)'); g.addColorStop(1,'rgba(90,60,10,.25)'); ctx.fillStyle=g; ctx.fillRect(0,0,W,W); } }
    var a=ctx.getImageData(0,0,W,W), b=draft.getContext('2d').getImageData(0,0,W,W).data, p=a.data;
    for(var i=0;i<p.length;i+=4){ var l=(b[i]*.3+b[i+1]*.59+b[i+2]*.11); var al=l<110?255:l>170?0:Math.round((170-l)/60*255); p[i+3]=al; }
    ctx.putImageData(a,0,0); return c;
  };
  M.render=function(d,V,fin,texUrl){
    return Promise.all([M.draft(d,V), texUrl?img(texUrl).catch(function(){return null;}):Promise.resolve(null)]).then(function(r){ return M.paint(r[0],fin,r[1]); });
  };
  // Zuschnitt: sichtbare Kante (längste Seite) für Maßstab bestimmen
  M.bbox=function(c){ var W=c.width, d=c.getContext('2d').getImageData(0,0,W,W).data, x0=W,y0=W,x1=0,y1=0;
    for(var y=0;y<W;y+=2) for(var x=0;x<W;x+=2){ if(d[(y*W+x)*4+3]>40){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; } }
    return {x0:x0,y0:y0,x1:x1,y1:y1,w:Math.max(1,x1-x0),h:Math.max(1,y1-y0)}; };
})();
